module.exports = __webpack_public_path__ + "static/media/dropoff_pass.2302522c.svg";